import app from "flarum/forum/app";
import RoundPage from "../RoundPage";

export default class ZSRoundPage extends RoundPage {
  oncreate(vnode: any) {
    super.oncreate(vnode);

    app.setTitle(app.translator.trans("rhodes-island.forum.rounds.zs_title") as string);
    app.setTitleCount(0);
  }

  content() {
    //<p className="Rounds--zs-tip">{app.translator.trans("rhodes-island.forum.rounds.zs_wip_tip", {a: <a href="https://rhd.tenmahw.com/query/zs/rounds"/>})}</p>
    return <div className="Placeholder">
      <p>{app.translator.trans("rhodes-island.forum.rounds.wip")}</p>
    </div>;
  }
}
